import React from 'react';

export default function LegalPage({ eyebrow, title, updated, children }) {
  return (
    <div>
      <section className="bg-teal-800 py-12 text-white">
        <div className="max-w-4xl mx-auto px-4 md:px-6">
          <div className="text-teal-200 uppercase tracking-widest text-xs font-semibold">{eyebrow}</div>
          <h1 className="font-display font-extrabold text-3xl md:text-4xl mt-2">{title}</h1>
          {updated && <div className="text-white/70 text-xs mt-2">Last updated: {updated}</div>}
        </div>
      </section>
      <section className="max-w-4xl mx-auto px-4 md:px-6 py-12">
        <div className="max-w-none text-slate-700 leading-relaxed space-y-3 [&_h2]:font-display [&_h2]:font-bold [&_h2]:text-slate-900 [&_h2]:text-xl [&_h2]:mt-8 [&_h2]:mb-2 [&_ul]:list-disc [&_ul]:pl-6 [&_ul]:space-y-1 [&_a]:text-teal-700 [&_a:hover]:underline [&_strong]:text-slate-900">
          {children}
        </div>
        <div className="mt-10 pt-6 border-t border-slate-200 text-xs text-slate-500">
          Cheapora (www.cheapora.com) is operated by Waan Travel Pte. Ltd. · UEN 202418948C · STB Licence TA03795 · 1 Soon Lee Street, #03-37 Pioneer Centre, Singapore 627605 · admin@waantravel.com
        </div>
      </section>
    </div>
  );
}
